export enum ProductionCompanyCodes {
    Dynamic = '',
    TIQ= 'AX-TIQ',
    AEA= 'AX-AEA',
    AEA_Test= 'AX-AEA-TEST',
    Baaj= 'AX-BAAJ',
    Baaj_Test= 'AX-BAAJ-TEST',
    RAS= 'AX-RAS',
    RAS_Test= 'AX-RAS-Test',
}